export const actionTypes = {
  GET_CHARACTERISTICS: 'GET_CHARACTERISTICS',
  GET_CHARACTER: 'GET_CHARACTER',
  GET_STATIC_DATA: 'GET_STATIC_DATA',
};